module.exports = __webpack_public_path__ + "media/images/pic/news-main-5f9d55b9f256b0d627187f94e63da5fa.jpg";